var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaste = function SvgPaste(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 5H8.205c-1.115 0-1.519.116-1.926.334a2.28 2.28 0 0 0-.945.945C5.116 6.686 5 7.09 5 8.205V16a1 1 0 1 1-2 0V8.128c0-1.783.186-2.43.534-3.082a3.64 3.64 0 0 1 1.512-1.512C5.698 3.186 6.345 3 8.128 3H16a1 1 0 1 1 0 2M8.279 7.334C8.686 7.116 9.09 7 10.205 7h7.59c1.115 0 1.519.116 1.926.334.403.213.732.542.945.945.218.407.334.811.334 1.926v7.59c0 1.114-.116 1.519-.334 1.926a2.28 2.28 0 0 1-.945.945c-.407.218-.811.334-1.926.334h-7.59c-1.114 0-1.519-.116-1.926-.334a2.28 2.28 0 0 1-.945-.945C7.116 19.314 7 18.91 7 17.795v-7.59c0-1.115.116-1.519.334-1.926.213-.403.542-.732.945-.945",
    clipRule: "evenodd"
  })));
};
export default SvgPaste;